import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {Error404Component} from './http-error/error404/error404.component';
import {LoginComponent} from '@module/users/login/login.component';
import {RegisterComponent} from '@module/users/register/register.component';
import {AuthGuard} from '~/app/shared/helpers/auth.guard';
import {AdminGuard} from '~/app/shared/helpers/admin.guard';
import {NewPasswordComponent} from '@module/users/new-password/new-password.component';
import {AffiliationComponent} from '@module/users/affiliation/affiliation.component';
import {OauthAuthorizeComponent} from '@module/users/oauth-authorize/oauth-authorize.component';
import {PartnersModule} from '@module/partners/partners.module';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/app/search/result',
        pathMatch: 'full',
    },
    {
        path: 'app/pricing',
        redirectTo: '/app/user/plan',
        pathMatch: 'full',
    },
    {
        path: 'app',
        redirectTo: '/app/search/result',
        pathMatch: 'full',
    },
    {
        path: 'app/share/:id',
        redirectTo: '/app/annonces/share/:id/annonce',
        pathMatch: 'full',
    },
    {
        path: 'app/share/:id/:tab',
        redirectTo: '/app/annonces/share/:id/:tab',
        pathMatch: 'full',
    },
    {
        path: 'app/rate',
        redirectTo: '/app/search/result#rate'
    },
    {
        path: 'app/login',
        component: LoginComponent
    },
    {
        path: 'app/partner/:affiliate',
        component: AffiliationComponent
    },
    {
        path: 'app/forgotPassword',
        component: NewPasswordComponent
    },
    {
        path: 'app/oauth/authorize',
        component: OauthAuthorizeComponent
    },
    {
        path: 'app/oauth',
        component: LoginComponent
    },
    {
        path: 'app/register',
        component: RegisterComponent
    },
    { // Public
        path: 'app',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule),
            },
            {
                path: 'annonces',
                loadChildren: () => import('./modules/annonces/annonces.module').then(m => m.AnnoncesModule),
            },
            // {
            //     path: 'share',
            //     loadChildren: () => import('./modules/share/share.module').then(m => m.ShareModule),
            // },
            {
                path: 'tools',
                loadChildren: () => import('./modules/tools/tools.module').then(m => m.ToolsModule),
            },
            {
                path: 'partners',
                loadChildren: () => import('./modules/partners/partners.module').then(m => m.PartnersModule),
            },
        ],
    },
    { // Private
        path: 'app',
        component: LayoutComponent,
        children: [
            {
                path: 'favorites',
                loadChildren: () => import('./modules/favorites/favorites.module').then(m => m.FavoritesModule),
            },
            {
                path: 'patrimoine',
                loadChildren: () => import('./modules/patrimoine/patrimoine.module').then(m => m.PatrimoineModule),
            },
            {
                path: 'historic',
                loadChildren: () => import('./modules/historic/historic.module').then(m => m.HistoricModule),
            },
            {
                path: 'appli-mobile',
                loadChildren: () => import('./modules/mobile-app/mobile-app.module').then(m => m.MobileAppModule),
            },
            {
                path: 'user',
                loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
            },
        ],
        canActivate: [AuthGuard]
    },
    { // Administration (réservé pro_plan = lybox)
        path: 'app',
        component: LayoutComponent,
        children: [
            {
                path: 'admin',
                loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
            },
        ],
        canActivate: [AdminGuard]
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '**',
                component: Error404Component
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
